export const hostName = window.location.host;

// Ces fonctions permettent de déterminer les url des appels API, redirection, etc, en fonction de l'url courante

export const getApiBaseUrl = () => {
    if (window.location.host === "localhost:3000") {
        const baseUrl = "https://v2.prevandcare.local:8890/api/internal";
        return baseUrl;
    }
    if (window.location.host === "localhost:3001") {
        const baseUrl = "https://v2.prevandcare.local:8890/api/internal";
        return baseUrl;
    } else {
        const baseUrl = "https://" + window.location.host + "/api/internal";
        return baseUrl;
    }
};

export const getBaseLoginUrl = () => {
    if (window.location.host === "localhost:3001") {
        const baseUrl = "http://localhost:3000";
        return baseUrl;
    } else if (window.location.host === "localhost:3000") {
        const baseUrl = "http://localhost:3001";
        return baseUrl;
    } else {
        const baseUrl = "https://" + window.location.host + "/modules/aidant/login/build";
        return baseUrl;
    }
};

export const getBaseMessagerieUrl = () => {
    if (window.location.host === "localhost:3000") {
        const baseUrl = "http://localhost:3000";
        return baseUrl;
    } else if (window.location.host === "localhost:3001") {
        const baseUrl = "http://localhost:3001";
        return baseUrl;
    } else {
        const baseUrl = "https://" + window.location.host + "/modules/aidant/messagerie/build";
        return baseUrl;
    }
};

export const getUploadUrl = () => {
    if (window.location.host === "localhost:3001") {
        const baseUrl = "https://v2.prevandcare.local:8890/uploads";
        return baseUrl;
    } else if (window.location.host === "localhost:3000") {
        const baseUrl = "https:/www.prevandcare.local:8890/uploads";
        return baseUrl;
    }
    const baseUrl = "https://" + window.location.host + "/uploads";
    return baseUrl;
};

export const getPartnerUrl = () => {
    if (window.location.host === "localhost:3001") {
        const baseUrl = "https://v2.prevandcare.local:8890/modules/partenaires";
        return baseUrl;
    } else if (window.location.host === "localhost:3000") {
        const baseUrl = "https:/www.prevandcare.local:8890/modules/partenaires";
        return baseUrl;
    }
    const baseUrl = "https://" + window.location.host + "/modules/partenaires";
    return baseUrl;
};
